import { connect } from "knockout-store";
import { pushRoute, r } from "../../utils/routing";
import startJs from "./start";
import { t } from "../../utils/translations";

function startViewModel(params) {
  setTimeout(() => {
    startJs();
  }, 0);

  const vm = {};
  vm.visible = () => params.route() === "/";
  vm.isActiveLanguage = (lang) => {
    if (process.env.LANGUAGE === lang) {
      return "active";
    }
  };

  vm.translation = (key) => t(key);
  vm.route = (key) => r(key);
  vm.goTo = (url) => {
    pushRoute(url, params.route);
  };

  return vm;
}

function mapStateToParams({ route }) {
  return { route };
}

export default connect(mapStateToParams)(startViewModel);
